export interface ImpersonationSession {
  identity: string;
  releaseUrl: '/hijack/release/' | '/support/return/';
}

export function readCsrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content
    || document.cookie.split('; ').find((item) => item.startsWith('csrftoken='))?.slice(10) || '';
}

// Identity switches use native POSTs and reload this authoritative Django bootstrap.
export function readImpersonation(): ImpersonationSession | null {
  try {
    const user = JSON.parse(document.getElementById('user-details')?.textContent || 'null');
    if (!user?.is_impersonating) return null;
    return {
      identity: user.email || user.username || 'Current user',
      releaseUrl: user.impersonation_kind === 'hijack' ? '/hijack/release/' : '/support/return/',
    };
  } catch {
    return null;
  }
}
